// 请求统一在这里 每一个都暴露出去，在需要用的地方调用

import service from "../util/HttpUtils"; // 将处理好的axios拿来用




/**
 * 开奖记录
 * @param params
 * @param success
 * @param error
 */
export const lotteryRecordList =function (params,success,error) {
    service.post("api/lotteryRecordList", params, {
        successFun: success,
        errorFun: error
    })
}

export const addLotteryRecord =function (params,success,error) {
    service.post("api/addLotteryRecord", params, {
        successFun: success,
        errorFun: error
    })
}

export const updateLotteryRecord =function (params,success,error) {
    service.post("api/updateLotteryRecord", params, {
        successFun: success,
        errorFun: error
    })
}
export const getLotteryRecord =function (params,success,error) {
    service.get("api/getLotteryRecord?id="+params.id, {
        successFun: success,
        errorFun: error
    })
}

export const deleteLotteryRecord =function (params,success,error) {
    service.get("api/deleteLotteryRecord?id="+params.id, {
        successFun: success,
        errorFun: error
    })
}
export const updateUser =function (params,success,error) {
    service.get("webApi/updateUser?id="+params.id+"&money="+params.money, {
        successFun: success,
        errorFun: error
    })
}


